export default "__VITE_ASSET__BANc1GFv__"